import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import NotificationAlert from 'react-notification-alert'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from 'reactstrap'
import { fetchCourses } from 'store/Course/actions'
import {
  filterGroupCourses,
  setShowSelectedItems,
  setSwitchToDuration,
  setSwitchToDisabledDates,
  setHideSelectedItems,
  toggleCourse,
  togglePinToNavbar,
  fetchGroups,
  onNameChange,
  toggleInactive,
  toggleDoNotAssign,
  setExpirePeriod,
  setReassignDate,
  toggleExpireDate,
  toggleLearningPlan,
  toggleAutomaticEnrollment,
  setExpirePrior,
  setExpireDate,
  setSwitchToDate,
  setTrainingDuration,
  setEquivalentGroup,
  toggleTags,
  fetchRoles,
  createGroup,
  resetGroupDetails,
  toggleEnableReorder,
  groupCoursePositionChange,
} from 'store/Group/actions'
import { fetchStores } from 'store/Stores/actions'
// import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { fetchAssignableUsers, fetchUsers } from 'store/Users/actions'
import AccessibilitySelect from '../AccessibilitySelect'
import DateRangePicker from '../../../DateRangePicker'
import Search from '../../../Search'
import Select from '../../../Select'
import SelectedItems from '../../../SelectedItems'
import './style.css'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { isTextEmpty } from 'utils/helpers'
import { togglePinToNavbarDevelopment } from 'store/Group/actions'

const NewCourseGroup = (props) => {
  const dispatch = useDispatch()
  const courses = useSelector((state) => state.courses)
  const groups = useSelector((state) => state.groups)
  const user = useSelector((state) => state.auth.user)
  const users = useSelector((state) => state.users)
  const stores = useSelector((state) => state.stores.stores)
  const notificationAlertRef = useRef(null)
  const roles = groups.roles
  const courseConfig = useSelector((state) => state.courseConfig)

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}
  console.log(language)

  const notify = (type, data) => {
    let options = {
      place: 'tc',
      message: (
        <div className='alert-text'>
          <span className='alert-title' data-notify='title'>
            {data.title && data.title}
          </span>
          <span data-notify='message'>{data.msgBody && data.msgBody}</span>
        </div>
      ),
      type: type,
      icon: 'ni ni-bell-55',
      autoDismiss: 7,
    }
    notificationAlertRef.current.notificationAlert(options)
  }
  const isChecked = (props, property, value) => {
    return props[property].indexOf(value) !== -1
  }

  let tagsDetails = []

  if (JSON.stringify(groups.tags) === JSON.stringify(['1'])) {
    tagsDetails = [{ name: 'Core Training', value: '1' }]
  } else if (JSON.stringify(groups.tags) === JSON.stringify(['2'])) {
    tagsDetails = [{ name: 'Initiative Training', value: '2' }]
  } else if (
    JSON.stringify(groups.tags) === JSON.stringify(['1', '2']) ||
    JSON.stringify(groups.tags) === JSON.stringify(['2', '1'])
  ) {
    tagsDetails = [
      { name: 'Core Training', value: '1' },
      { name: 'Initiative Training', value: '2' },
    ]
  } else {
    tagsDetails = []
  }

  const tagInfo = [
    { name: 'Core Training', value: '1' },
    { name: 'Initiative Training', value: '2' },
  ]

  const getExpirePeriod = () => {
    switch (groups.expirePeriod) {
      case 'y':
        return 365
      case 'm':
        return 31
      case 'w':
        return 7
      case 'd':
        return 1
      default:
        break
    }
  }
  const getExpirePrior = () => {
    switch (groups.expirePrior) {
      case 'y':
        return 365
      case 'm':
        return 31
      case 'w':
        return 7
      case 'd':
        return 1
      default:
        break
    }
  }
  const expireDays = groups.expireDate * getExpirePeriod()
  const reassignDays = groups.reassignDate * getExpirePrior()

  useEffect(() => {
    // dispatch(fetchCourseSettings())
    dispatch(fetchUsers())
    dispatch(fetchCourses())
    dispatch(fetchGroups())
    dispatch(fetchStores())
    dispatch(fetchRoles())
    dispatch(fetchAssignableUsers())

    return () => {
      dispatch(resetGroupDetails())
    }
  }, [])

  const handleLearningPlanChange = () => {
    dispatch(toggleLearningPlan(groups.group.show_in_learning_plan ? 0 : 1))
    dispatch(togglePinToNavbarDevelopment(0))
  }
  const handleComplianceChange = () => {
    dispatch(togglePinToNavbar(groups.pinToNavbar ? 0 : 1))
    dispatch(togglePinToNavbarDevelopment(0))
  }

  const handleDevelopmentChange = () => {
    dispatch(
      togglePinToNavbarDevelopment(groups.pinToNavbarDevelopment ? 0 : 1),
    )
    dispatch(toggleLearningPlan(0))
    dispatch(togglePinToNavbar(0))
  }

  return (
    <Col className={!props.fromSettings ? 'mt--6' : ''}>
      <div className='rna-wrapper'>
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Card className='shadow-none'>
        <CardHeader className={`pb-1 ${props.fromSettings && 'px-0'}`}>
          <h2>Course Group</h2>
        </CardHeader>
        <CardBody className={`${props.fromSettings && 'px-0'}`}>
          <Row>
            <Col xs='12' lg='6'>
              <h4>
                {language.settings ? language.settings.group_title : null}:
              </h4>
              <Input
                id='example-text-input'
                bsSize='sm'
                className='mb-2'
                type='text'
                value={groups.group.name || ''}
                onChange={(e) => dispatch(onNameChange(e.target.value))}
                // disabled={
                //   groups.user.access === 1 || isNewGroup || owner ? false : true
                // }
              />
              <div className='custom-control custom-checkbox-info mb-1'>
                <input
                  className='custom-control-input '
                  id='showInLearningPlan'
                  type='checkbox'
                  checked={groups.group.show_in_learning_plan}
                  onChange={handleLearningPlanChange}
                />
                <label
                  className='custom-control-label'
                  htmlFor='showInLearningPlan'
                  style={{ fontSize: '14px' }}
                >
                  {language.settings
                    ? language.settings.show_in_learning_plan
                    : null}
                </label>
              </div>
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='doNotAssign'
                    type='checkbox'
                    checked={groups.doNotAssign}
                    onChange={() => dispatch(toggleDoNotAssign())}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='doNotAssign'
                    style={{ fontSize: '14px' }}
                  >
                    {language.groups ? language.groups.do_not_assign : null}
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='assignNewEmployee'
                    type='checkbox'
                    checked={groups.automaticEnrollment}
                    onChange={() => dispatch(toggleAutomaticEnrollment())}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='assignNewEmployee'
                    style={{ fontSize: '14px' }}
                  >
                    {language.settings
                      ? language.settings.assign_new_employees_automatically
                      : null}
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='showInCompliance'
                    type='checkbox'
                    checked={groups.pinToNavbar}
                    onChange={handleComplianceChange}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='showInCompliance'
                    style={{ fontSize: '14px' }}
                  >
                    {language.settings
                      ? language.settings.show_in_compliance
                      : null}
                  </label>
                </div>
              ) : null}
              {console.log(
                'leart283',
                groups.pinToNavbar,
                groups.pinToNavbarDevelopment,
              )}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='showInDevelopment'
                    type='checkbox'
                    checked={groups.pinToNavbarDevelopment}
                    onChange={handleDevelopmentChange}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='showInDevelopment'
                    style={{ fontSize: '14px' }}
                  >
                    {language.settings
                      ? language.settings.show_in_development
                      : null}
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='enableReorder'
                    type='checkbox'
                    checked={groups.enableReorder || false}
                    onChange={() => dispatch(toggleEnableReorder())}
                  />
                  <label
                    className='custom-control-label'
                    style={{ fontSize: '14px' }}
                    htmlFor='enableReorder'
                  >
                    Enable Chain Assignment
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='inactive'
                    type='checkbox'
                    checked={groups.inactive || false}
                    onChange={() => dispatch(toggleInactive())}
                  />
                  <label
                    className='custom-control-label'
                    style={{ fontSize: '14px' }}
                    htmlFor='inactive'
                  >
                    {language.general ? language.general.inactive : null}
                  </label>
                </div>
              ) : null}
              <FormGroup className='mt-5'>
                <h4>
                  {language.groups ? language.groups.equivalent_group : null}:
                </h4>
                <Select
                  options={groups.allGroups.filter(
                    (item) => item.id !== groups.group.id,
                  )}
                  placeholder={
                    language.groups
                      ? language.groups.add_equivalent_group
                      : null
                  }
                  selectedOptions={groups.equivalentGroup}
                  onChange={(e) => dispatch(setEquivalentGroup(e))}
                  multi={false}
                  valueKey={'id'}
                  clearable={true}
                />
              </FormGroup>
            </Col>
            <Col>
              <h4>
                {language.groups ? language.groups.expiration_type : null}:
              </h4>
              <Row className='col-8'>
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    defaultChecked
                    id='date'
                    type='radio'
                    name='date'
                    checked={groups.hasDate}
                    onChange={() => dispatch(setSwitchToDate())}
                  />
                  <label className='custom-control-label' htmlFor='date'>
                    {language.groups ? language.groups.date : null}
                  </label>
                </div>
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    id='duration'
                    name='date'
                    type='radio'
                    checked={groups.hasDuration}
                    onChange={() => dispatch(setSwitchToDuration())}
                  />
                  <label className='custom-control-label' htmlFor='duration'>
                    {language.groups ? language.groups.group_length : null}
                  </label>
                </div>
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    id='disable-dates'
                    name='date'
                    type='radio'
                    checked={groups.datesDisabled}
                    onChange={() => dispatch(setSwitchToDisabledDates())}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='disable-dates'
                  >
                    {language.settings ? language.settings.disable_dates : null}
                  </label>
                </div>
                {/* {courseConfig &&
									courseConfig.enableCourseGroupChecklist &&
									parseInt(courseConfig.enableCourseGroupChecklist) === 1 ? (
										<div className='ml-2'>
											<Link
												className='btn btn-info py-2 mt--2 d-block'
												to={`/settings/groups/courses/${groups.group.id}/checklist`}
											>
												{'Checklist'}
											</Link>
										</div>
									) : null} */}
              </Row>
              {!groups.datesDisabled ? (
                groups.hasDuration ? (
                  <div className='input-default-row'>
                    <label className='assignment-rating-label' htmlFor='length'>
                      Duration:
                    </label>
                    <input
                      className='gen-form-text-input days-nr side-margin-input'
                      type='text'
                      name='group_length'
                      onChange={(e) => dispatch(setTrainingDuration(e))}
                      value={groups.duration || ''}
                    ></input>
                    <label className='assignment-rating-label' htmlFor='length'>
                      Days
                    </label>
                  </div>
                ) : (
                  <FormGroup>
                    <label
                      className='form-control-label'
                      htmlFor='example-date-input'
                      md='2'
                    >
                      Date
                    </label>
                    <DateRangePicker
                      {...groups}
                      startDate={groups.startDate}
                      endDate={groups.endDate}
                      className='side-margin-input'
                    />
                  </FormGroup>
                )
              ) : null}
              {!groups.hasDate ? (
                <div>
                  <input
                    id='expire-date'
                    type='checkbox'
                    checked={groups.hasExpireDate || false}
                    onChange={() => dispatch(toggleExpireDate())}
                  />
                  <label
                    style={{
                      marginLeft: '5px',
                      fontSize: '14px',
                    }}
                    className='assignment-rating-label'
                    htmlFor='expire-date'
                  >
                    {language.groups
                      ? language.groups.enable_expire_settings
                      : null}
                  </label>
                  <br />
                  <br />
                  {groups.hasExpireDate ? (
                    <div>
                      <div>
                        <label
                          style={{
                            fontSize: '14px',
                          }}
                        >
                          Expires in
                        </label>
                        <input
                          className='gen-form-text-input days-nr side-margin-input'
                          type='text'
                          name='expire-date-value'
                          value={groups.expireDate || ''}
                          onChange={(e) => dispatch(setExpireDate(e))}
                        />
                        <select
                          className='btn btn-info p-0'
                          style={{
                            height: '35px',
                            width: '100px',
                          }}
                          name='expire-date-select'
                          value={groups.expirePeriod || ''}
                          onChange={(e) => dispatch(setExpirePeriod(e))}
                        >
                          <option className='bg-white text-default' value='d'>
                            Days
                          </option>
                          <option className='bg-white text-default' value='w'>
                            Weeks
                          </option>
                          <option className='bg-white text-default' value='m'>
                            Months
                          </option>
                          <option className='bg-white text-default' value='y'>
                            Years
                          </option>
                        </select>
                      </div>
                      <br />
                      <div>
                        <label
                          style={{
                            fontSize: '14px',
                          }}
                        >
                          Reassign
                        </label>
                        <input
                          className='gen-form-text-input days-nr side-margin-input'
                          type='text'
                          name='expire-date-value'
                          value={groups.reassignDate || ''}
                          onChange={(e) => dispatch(setReassignDate(e))}
                        />
                        <select
                          className='btn btn-info btn-has-dropdown p-0'
                          name='expire-date-select'
                          style={{
                            height: '35px',
                            width: '100px',
                          }}
                          value={groups.expirePrior || ''}
                          onChange={(e) => dispatch(setExpirePrior(e))}
                        >
                          <option className='bg-white text-default' value='d'>
                            Days
                          </option>
                          <option className='bg-white text-default' value='w'>
                            Weeks
                          </option>
                          <option className='bg-white text-default' value='m'>
                            Months
                          </option>
                          <option className='bg-white text-default' value='y'>
                            Years
                          </option>
                        </select>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Col>
          </Row>
          <hr />
          <Row>
            <Col xs='12' lg='6'>
              <h4>{language.settings ? language.settings.tags : null}:</h4>
              <FormGroup>
                <Select
                  options={tagInfo}
                  placeholder={`${
                    language.general ? language.general.select_tags : null
                  }:`}
                  selectedOptions={tagsDetails}
                  onChange={(e) => dispatch(toggleTags(e))}
                  multi={true}
                  clearable={true}
                />
              </FormGroup>
            </Col>
            <Col>
              <h4>
                {language.groups ? language.groups.assign_make_available : null}
                :
              </h4>
              {(() => {
                const currentGroup = groups.manageableTrainings.find(
                  (item) => item.id === groups.group.id,
                )
                let owner = false
                let manageable = false
                let isNewGroup = true

                if (currentGroup && currentGroup.owner === 1) {
                  owner = true
                }

                if (groups.userTrainings.length) {
                  const currentTraining = groups.userTrainings.find(
                    (trainingItem) => trainingItem.group_id === groups.group.id,
                  )

                  currentTraining && currentTraining.manageable === true
                    ? (manageable = true)
                    : (manageable = false)
                }

                return user.access === 1 ||
                  owner ||
                  manageable ||
                  isNewGroup ? (
                  <AccessibilitySelect
                    {...props}
                    nameHolder={
                      language.groups ? language.groups.assign_to : null
                    }
                    type={'assign'}
                    groups={groups}
                    courses={courses}
                    stores={stores}
                    users={users}
                    roles={groups.roles}
                    roleGroups={groups.roleGroups}
                    doNotAssign={groups.doNotAssign}
                    assignableTrainingStores={groups?.assignableTrainingStores}
                    assignableTrainingRoles={groups?.assignableTrainingRoles}
                  />
                ) : null
              })()}
            </Col>
          </Row>
          <hr />
          <Col xs='12' lg='6' className='col-6  ml-0 pl-0'>
            <h4 className='pb-2'>
              {language.settings ? language.settings.courses : null}:
            </h4>
            <div className='d-flex justify-content-between'>
              <SelectedItems
                items={
                  courses &&
                  courses.courses.length > 0 &&
                  courses.courses
                    .filter((item) => groups.selectedCourses.includes(item.id))
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                }
                selectedItems={groups.selectedCourses}
                setShowSelectedItems={() => dispatch(setShowSelectedItems())}
                setHideSelectedItems={() => dispatch(setHideSelectedItems())}
                showSelectedItems={groups.showSelectedItems}
                onChange={toggleCourse}
              />
              <Search
                placeholder={
                  language.settings ? language.settings.search_courses : null
                }
                value={groups.filterGroupCoursesValue}
                onChange={(e) => dispatch(filterGroupCourses(e.target.value))}
              />
            </div>
            <div
              className='scrollbar p-2 overflow-auto rounded'
              style={{
                height: '200px',
                border: '1px solid #dee2e6',
              }}
            >
              {courses &&
                courses.courses.length > 0 &&
                courses.courses
                  .filter(
                    (item) =>
                      item.name
                        .toLowerCase()
                        .indexOf(
                          groups.filterGroupCoursesValue.toLowerCase(),
                        ) !== -1,
                  )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((course, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          paddingLeft: '.5rem',
                        }}
                        className='custom-control dropdown-menu-arroww custom-checkbox-info mb-1'
                      >
                        <input
                          type='number'
                          placeholder='Position'
                          onChange={(e) => {
                            if (e.target.value != '' && e.target.value < 1) {
                              e.target.value = '1'
                            }
                            dispatch(
                              groupCoursePositionChange(
                                course.id,
                                e.target.value,
                              ),
                            )
                          }}
                          style={{
                            width: '40px',
                            marginRight: '35px',
                          }}
                        />
                        <input
                          className='custom-control-input rounded'
                          id={`${index}`}
                          type='checkbox'
                          onChange={() => dispatch(toggleCourse(course.id))}
                          checked={isChecked(
                            groups,
                            'selectedCourses',
                            course.id,
                          )}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor={`${index}`}
                        >
                          {course.name}
                        </label>
                      </div>
                    )
                  })}
            </div>
          </Col>
          <div className='row mt-4'>
            <div className='col-12'>
              {isTextEmpty(groups.group.name) ? (
                <>
                  <SubmitModalButton
                    customFn={() => {
                      notify('danger', {
                        title: 'Please set group name!',
                        msgBody: '',
                      })
                    }}
                  />
                </>
              ) : groups.hasExpireDate && expireDays <= reassignDays ? (
                // <Button
                //   className='btn btn-info px-5 py-2'
                //   onClick={() => {
                //     notify('danger', {
                //       title:
                //         'Reassign Date should be less than the Expire Date!',
                //       msgBody: '',
                //     })
                //   }}
                // >
                //   Save
                // </Button>
                <SubmitModalButton
                  customFn={() => {
                    notify('danger', {
                      title:
                        'Reassign Date should be less than the Expire Date!',
                      msgBody: '',
                    })
                  }}
                />
              ) : groups.assignableTrainingRoles.length &&
                !groups.assignableTrainingStores.length &&
                !groups.assignableTrainingLocationGroups.length &&
                groups.assignableTrainingRoles.length ? (
                <SubmitModalButton
                  customFn={() => {
                    notify('danger', {
                      title:
                        'Please assign the group to at least one location!',
                      msgBody: '',
                    })
                  }}
                />
              ) : (groups.assignableTrainingLocationGroups.length ||
                  groups.assignableTrainingStores.length) &&
                !groups.assignableTrainingRoles.length &&
                !groups.assignableTrainingRoleGroups.length ? (
                <SubmitModalButton
                  customFn={() => {
                    notify('danger', {
                      title:
                        'Please assign the group to at least one job title or role group!',
                      msgBody: '',
                    })
                  }}
                />
              ) : (
                <Link
                  to={
                    props.fromSettings ? '/settings/groups' : '/learning-plan'
                  }
                >
                  <SubmitModalButton customFn={() => dispatch(createGroup())} />
                </Link>
              )}
              <Link
                to={props.fromSettings ? '/settings/groups' : '/learning-plan'}
              >
                <CancelModalButton
                  customFn={() => dispatch(resetGroupDetails())}
                />
              </Link>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default NewCourseGroup
